module.exports = __webpack_public_path__ + "img/13.e3772866.png";